import { createTheme } from "@mui/material/styles";

const breakpoints = {
  values: {
    xs: 0,
    ss: 380,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1512,
  },
};

export const theme = createTheme({
  breakpoints,
  palette: {
    primary: {
      main: "#2E7FC3",
      light: "#75B129",
    },
    secondary: {
      main: "#78AE2A",
    },
  },
  typography: {
    fontSize: 16,
    h1: {
      fontSize: "4rem",
      fontWeight: 700,
    },
    h2: {
      fontSize: "2.85rem",
      fontWeight: 700,
    },
    h3: {
      fontSize: "1.875rem",
      fontWeight: 700,
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 600,
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 600,
    },
    h6: {
      fontSize: "1.125",
      fontWeight: 600,
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    body2: {
      fontSize: "0.875rem",
      fontWeight: 400,
    },
  },
});
